module.exports = __webpack_public_path__ + "static/media/index-logo-text.6655d2a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/siamoption/index-logo-text.svg
// module id = 1228
// module chunks = 103